import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation ,useNavigate} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function EditUser() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    password: "",
  });
  const [disableBtn, setDisableBtn] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  
  const data = location.state.data;

  console.log("Data from location state:", data);

  useEffect(() => {
    if (data) {
      setFormData({
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        phone: data.phone || "",
        address: data.address || "",
        password: "", // Password should not be pre-filled for security reasons,
        status: data.status,
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    console.log("Name", name);
    console.log("Value", value);

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log("FromData", formData);
      const formdata = new FormData();
      formdata.append("userId", data._id);
      formdata.append("email", formData.email);
      formdata.append("firstName", formData.firstName);
      formdata.append("lastName", formData.lastName);
      formdata.append("phone", formData.phone);
      formdata.append("status", formData.status);
      if (formData.password) {
        formdata.append("password", formData.password);
      }
      if (formData.address) {
        formdata.append("address", formData.address);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user/update-user`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit user. Please try again.", error);
    }
    setDisableBtn(false);
  };

  console.log("Form Data:", formData);

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Update User</h2>
                <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
            >
              Back
            </button>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    First Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter First NAme"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Last Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Email
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Phone Number
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Phone Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Password
                  </label>{" "}
                  <br />
                  <input
                    type="password"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    // required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Status
                  </label>{" "}
                  <br />
                  <select
                    name="status"
                    id="status"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    value={formData.status}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="Active">Active</option>
                    <option value="Blocked">Blocked</option>
                  </select>
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-edit"></i>{" "}
                    {disableBtn ? "Updating ..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
